import { useQuery } from '@tanstack/react-query';
import { QuestionCategory } from '../interfaces/question.category.interface';
import { agentsApi } from '../services/agents-api.service';

const useGetQuestions = () => {
    const getQuersionsQuery = useQuery<QuestionCategory[]>({
        queryKey: ['questions'],
        queryFn: () => agentsApi.getAllQuestions(),
    });
    return {
        getQuersionsQuery,
    };
};

export default useGetQuestions;
